import React from 'react';
import { Breadcrumb, NeoDateRangePicker, NeoButton } from "../../../components/Common";
import { useCashFlow } from './hooks/useCashFlow';
import { CashFlowTable } from './components/CashFlowTable';

/**
 * CashFlowPage
 * Fluxo de Caixa Projetado — mesmo padrão de Receivables/Payables.
 */
const CashFlowPage = () => {
    document.title = "Fluxo de Caixa Projetado | NeoApp - Sistema de Gestão";

    const {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        bankAccounts,
        currentTotalBalance,
        projectedDays,
        loading,
        hasSearched,
        handleSearch
    } = useCashFlow();

    return (
        <React.Fragment>
            {/* TOP BAR: Cabeçalho & Filtro de Período Lado a Lado */}
            <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between mb-4 gap-3">
                <div>
                    <Breadcrumb title="Fluxo de Caixa" />
                    <p className="text-muted mb-0 font-size-13 mt-0.5">
                        Projeção de entradas, saídas e saldo dia a dia com base nos lançamentos financeiros.
                    </p>
                </div>

                <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2 flex-shrink-0">
                    <NeoDateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        onChange={({ startDate: start, endDate: end }) => {
                            if (start !== undefined) setStartDate(start);
                            if (end !== undefined) setEndDate(end);
                        }}
                        size="sm"
                        className="mb-0 neo-daterangepicker-filter"
                        placeholder="Selecione o período..."
                    />
                    <NeoButton
                        variant="primary"
                        onClick={handleSearch}
                        loading={loading}
                        disabled={!startDate || !endDate}
                        title="Buscar"
                        icon="mdi-magnify"
                        size="sm"
                        square
                        className="neo-filter-search-btn"
                    />
                </div>
            </div>

            <div className="border-top mb-4"></div>

            {/* ═══ TABELA ═══ */}
            <CashFlowTable
                projectedDays={projectedDays}
                loading={loading}
                currentTotalBalance={currentTotalBalance}
                bankAccountsCount={bankAccounts.length}
                hasSearched={hasSearched}
            />
        </React.Fragment>
    );
};

export default CashFlowPage;
